import React, { useEffect, useContext, useState } from 'react';

import {
    LinearProgress,
    Grid
} from '@material-ui/core';

import {
    PageHeader
} from '../../../common';

import {
    TableList
} from './components';

import { PageProvider, PageContext } from './PageContext';
import { NavContext, NavRoutes } from '../../../contexts';
import { ToastContext } from '../../../contexts';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
    root: {
    }
});

const PageContent = (props) => {
    const classes = useStyles();

    const {
        state,
        pageIsReady,
        setPageIsReady,
        isBusy,
        setIsBusy,
        getTablesAsync,
        toggleTableAvailabilityAsync,
        toggleTableAllowImportAsync,
        toggleTableClearOnImportAsync,
        syncExternalTablesAsync
    } = useContext(PageContext);

    const {
        navigateTo
    } = useContext(NavContext);

    const {
        showSuccessMessage
    } = useContext(ToastContext);

    const {
        tables
    } = state;

    const [searchText, setSearchText] = useState(null);
    const searchClickHandler = async (searchText) => {
        setSearchText(searchText);
    };

    const loadMoreHandler = async (searchText, pageIndex, pageSize) => {
        setIsBusy({ loadMore: true });
        await getTablesAsync(searchText, false, pageIndex, pageSize);
        setIsBusy({ loadMore: false });
    }

    const viewTableHandler = (table) => {
        navigateTo(NavRoutes.Admin.Table, [table.managedTableId]);
    }

    const toggleAvailabilityHandler = async (table) => {
        setIsBusy({ toggleTable: true });
        await toggleTableAvailabilityAsync({
            tableId: table.managedTableId,
            isDisabled: !table.isDisabled
        });
        setIsBusy({ toggleTable: false });
    }

    const toggleAllowImportHandler = async (table) => {
        setIsBusy({ toggleTable: true });
        await toggleTableAllowImportAsync({
            tableId: table.managedTableId,
            allowImport: !table.allowImport
        });
        setIsBusy({ toggleTable: false });
    }

    const toggleClearOnImportHandler = async (table) => {
        setIsBusy({ toggleTable: true });
        await toggleTableClearOnImportAsync({
            tableId: table.managedTableId,
            clearOnImport: !table.clearOnImport
        });
        setIsBusy({ toggleTable: false });
    }

    const syncTablesHandler = async () => {
        setIsBusy({ syncTables: true });
        await syncExternalTablesAsync();
        await getTablesAsync(searchText, false, 0, 20);
        showSuccessMessage("Synchronization completed!");
        setIsBusy({ syncTables: false });
    }

    const manageUsersHandler = (table) => {
        navigateTo(NavRoutes.Admin.TableUsers, [table.managedTableId]);
    }

    useEffect(() => {
        getTablesAsync(searchText, false, 0, 20);
    }, []);

    useEffect(() => {
        setPageIsReady(tables !== null)
    }, [tables]);

    return (
        <>
            {pageIsReady ?
                <Grid container spacing={3} className={classes.root}>
                    <Grid item xs={12}>
                        <PageHeader
                            save
                            saveButtonText="Synchronize"
                            onSaveClick={syncTablesHandler}
                            search
                            title="CRUD Tables"
                            subtitle="View and manage crud tables"
                            disabled={isBusy()}
                            onSearchClick={searchClickHandler}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TableList
                            searchText={searchText}
                            itemsPerPage={20}
                            loading={isBusy("loadMore")}
                            disabled={isBusy()}
                            onViewTable={viewTableHandler}
                            onToggleAvailability={toggleAvailabilityHandler}
                            onToggleAllowImport={toggleAllowImportHandler}
                            onToggleClearOnImport={toggleClearOnImportHandler}
                            onManageUsers={manageUsersHandler}
                            onLoadMore={loadMoreHandler}
                        />
                    </Grid>
                </Grid>
                :
                <LinearProgress />
            }
        </>
    );
}

export const TablesPage = () => {

    return (
        <PageProvider>
            <PageContent />
        </PageProvider>
    );
}